import PropTypes from 'prop-types';
import React, { useEffect, useRef, useCallback } from 'react';

//Import Icons
import Icon from '@ailibs/feather-react-ts';

// //Import Scrollbar
import SimpleBar from 'simplebar-react';

//i18n
import { withTranslation } from 'react-i18next';

// MetisMenu
import MetisMenu from 'metismenujs';
import { Link, withRouter } from 'react-router-dom';

const SidebarContent = (props: any) => {
  const ref = useRef<any>();

  const activateParentDropdown = useCallback((item: any) => {
    item.classList.add('active');
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu('#side-menu');
      let matchingMenuItem = null;
      const ul: any = document.getElementById('side-menu');
      const items = ul.getElementsByTagName('a');
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: '100%' }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/dashboard" className="">
                <Icon name="home" />
                <span>{props.t('Dashboard')}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <Icon name="database" />
                <span>{props.t('Assets')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/assets">{props.t('All')}</Link>
                </li>
                <li>
                  <Link to="/assets/create">{props.t('Create')}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <Icon name="filter" />
                <span>{props.t('Categories')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/categories">{props.t('All')}</Link>
                </li>
                <li>
                  <Link to="/categories/create">{props.t('Create')}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <Icon name="user" />
                <span>{props.t('Users')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/users">{props.t('All')}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <Icon name="list" />
                <span>{props.t('Banking')}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Banking">{props.t('All')}</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
};

export default withTranslation()(withRouter(SidebarContent));
